export const setAssetCompany = (id: number) => {
  return {
    type: 'ON_SET_COMPANY',
    payload: id,
  }
}
